(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    const setupNewsletterPopup = () => {
  const popup = document.getElementById('NewsletterPopup');
  if (!popup || popup.dataset.bound) return;
  popup.dataset.bound = 'true';
  let lastFocusedElement;
  const sessionKey = 'zarrii-newsletter-seen';
  const open = () => {
    if (popup.open || typeof popup.showModal !== 'function') return;
    lastFocusedElement = document.activeElement;
    popup.showModal();
    try { sessionStorage.setItem(sessionKey, '1'); } catch (error) {}
    popup.querySelector('[data-newsletter-popup-close]').focus();
  };
  const close = () => {
    if (!popup.open) return;
    popup.close();
    if (lastFocusedElement instanceof HTMLElement && lastFocusedElement !== document.body) lastFocusedElement.focus();
  };
  document.querySelectorAll('[data-newsletter-popup-open]').forEach(button => button.addEventListener('click', open));
  popup.querySelector('[data-newsletter-popup-close]').addEventListener('click', close);
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.addEventListener('click', event => { if (event.target === popup) close(); });
  if (location.hash === '#NewsletterPopupForm' && popup.querySelector('[data-newsletter-response]')) {
    try { sessionStorage.setItem(sessionKey, '1'); } catch (error) {}
    open();
    return;
  }
  let seen = false;
  try { seen = sessionStorage.getItem(sessionKey) === '1'; } catch (error) {}
  if (!seen) {
    const autoOpen = () => {
      if (document.hidden || document.querySelector('dialog[open]')) {
        window.setTimeout(autoOpen, 2000);
        return;
      }
      open();
    };
    window.setTimeout(autoOpen, 8000);
  }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupNewsletterPopup, { once: true });
else setupNewsletterPopup();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const initProductPreviews = (root = document) => {
  root.querySelectorAll('.product-card').forEach(card => {
    const secondary = card.querySelector('.hover-image');
    if (!secondary || card.dataset.previewBound) return;
    card.dataset.previewBound = 'true';
    const ready = () => { if (secondary.naturalWidth > 0) card.classList.add('preview-ready'); };
    secondary.addEventListener('load', ready);
    secondary.addEventListener('error', () => card.classList.remove('preview-ready', 'is-preview'));
    if (secondary.complete) ready();
    card.querySelector('.product-photo').addEventListener('click', event => {
      if (!matchMedia('(hover: none), (pointer: coarse)').matches || event.detail === 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (!card.classList.contains('preview-ready') || card.classList.contains('is-preview')) return;
      event.preventDefault();
      document.querySelectorAll('.product-card.is-preview').forEach(other => other.classList.remove('is-preview'));
      card.classList.add('is-preview');
    });
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initProductPreviews(), {once:true});
else initProductPreviews();
document.addEventListener('shopify:section:load', event => initProductPreviews(event.target));
document.addEventListener('pointerdown', event => {
  document.querySelectorAll('.product-card.is-preview').forEach(card => {
    if (!card.contains(event.target)) card.classList.remove('is-preview');
  });
});
  } catch(e) { console.error(e); }
})();

})();
